import { render, staticRenderFns } from "./KeyPoints.vue?vue&type=template&id=2d46c6a3&scoped=true&"
import script from "./KeyPoints.vue?vue&type=script&lang=js&"
export * from "./KeyPoints.vue?vue&type=script&lang=js&"
import style0 from "./KeyPoints.vue?vue&type=style&index=0&id=2d46c6a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d46c6a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d46c6a3')) {
      api.createRecord('2d46c6a3', component.options)
    } else {
      api.reload('2d46c6a3', component.options)
    }
    module.hot.accept("./KeyPoints.vue?vue&type=template&id=2d46c6a3&scoped=true&", function () {
      api.rerender('2d46c6a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/option/KeyPoints.vue"
export default component.exports